import { FormControl, Input } from 'components/ui';

export const BirthdayInput = ({
  birthdayError,
  birthday,
  handleBirthdayChange,
  isMobile,
}: {
  birthdayError: string;
  birthday: string;
  handleBirthdayChange: (value: string) => void;
  isMobile?: boolean;
}) => (
  <FormControl invalid={!!birthdayError} required={true}>
    <FormControl.Label alignItems={'flex-start'}>
      Date of Birth
    </FormControl.Label>

    <Input
      borderColor={birthdayError ? 'error.500' : undefined}
      maxWidth={'100%'}
      onChange={(e) => handleBirthdayChange(e.target.value)}
      placeholder="MM/DD/YYYY"
      type="text"
      value={birthday || ''}
    />

    {birthdayError && (
      <FormControl.ErrorMessage mt={0}>
        {birthdayError}
      </FormControl.ErrorMessage>
    )}
  </FormControl>
);
